var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#0061FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3657 6.23435C15.5157 6.38437 15.5999 6.58782 15.5999 6.79995C15.5999 7.01208 15.5157 7.21553 15.3657 7.36555L8.96568 13.7656C8.81566 13.9155 8.61221 13.9998 8.40008 13.9998C8.18795 13.9998 7.9845 13.9155 7.83448 13.7656L4.63448 10.5656C4.48876 10.4147 4.40812 10.2126 4.40994 10.0028C4.41177 9.79307 4.4959 9.59242 4.64423 9.4441C4.79255 9.29577 4.9932 9.21163 5.20296 9.20981C5.41272 9.20799 5.6148 9.28863 5.76568 9.43435L8.40008 12.0688L14.2345 6.23435C14.3845 6.08437 14.588 6.00012 14.8001 6.00012C15.0122 6.00012 15.2157 6.08437 15.3657 6.23435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxChecked);
export default __webpack_public_path__ + "static/media/check-box-checked.7a6f1517ef1aad2a2b44857bbfca57b9.svg";
export { ForwardRef as ReactComponent };